import { css } from "@emotion/react";
import { colors } from "../../colors";

export const returnCheckboxAndRadioStyleInputStyle = (borderRadius: string) => {
  return css`
    > input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    > input:checked ~ .customElement {
      background-color: ${colors.blueInteractive};
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4),
        0px 0px 0px 1px ${colors.blueLight};
      > .checkedIndicator {
        opacity: 100;
      }
    }

    > input:disabled ~ .customElement {
      background-color: ${colors.ctaInactive};
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2),
        0px 0px 0px 1px ${colors.greyBorder};
      &:hover {
        > .customElement {
          // TODO: Get grey into theme
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2),
            0px 0px 0px 1px ${colors.greyBorder};
          background-color: ${colors.whiteHover};
        }
      }
      > .checkedIndicator {
        opacity: 0;
      }
    }

    > input:checked ~ .checkedIndicator {
      opacity: 100;
    }

    > .customElement {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 20px;
      width: 20px;
      min-width: 20px;
      min-height: 20px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2),
        0px 0px 0px 1px ${colors.greyBorder};
      border-radius: ${borderRadius};
      > .checkedIndicator {
        opacity: 0;
        color: ${colors.white};
      }
    }
  `;
};

export const returnCheckboxAndRadioStyle = (
  borderRadius: string,
  wrapperWidth?: string
) => {
  return css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin-bottom: 0px;
    width: ${wrapperWidth ?? "fit-content"};
    cursor: pointer;
    &:hover {
      > .customElement {
        background-color: ${colors.whiteHover};
      }
    }
    ${returnCheckboxAndRadioStyleInputStyle(borderRadius)}
  `;
};
